"use client"

import { CircleSmall } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CircleSmallIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CircleSmallIcon = component(Icon)({ as: CircleSmall })
